import { render, staticRenderFns } from "./DmsPdfDialog.vue?vue&type=template&id=70032507&"
import script from "./DmsPdfDialog.vue?vue&type=script&lang=js&"
export * from "./DmsPdfDialog.vue?vue&type=script&lang=js&"
import style0 from "./DmsPdfDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports